import * as yup from 'yup'

export const societyDocumentFolderCreateSchema = yup
  .object({
    name: yup.string().required(),
    description: yup.string().optional(),
    thumbnail: yup.string().optional(),
    notificationSettings: yup
      .string()
      .oneOf(['none', 'notification'])
      .optional(),
  })
  .required()
